// 文章类型初始值
export const InitialArticleType = {
    id: 0,
    type_name: "",
    name: "",
    color_code: "#FF6900",
    hidden: false,
}
